"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1939],{

/***/ 11939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ProcessTimeline": function() { return /* binding */ ProcessTimeline; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/sections/ProcessTimeline/processTimeline.style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    bottom: -300px;\n    margin: -300px auto 0;\n    padding-bottom: 2.5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    bottom: -300px;\n    margin: -300px auto 0;\n    padding-bottom: 64px;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: -200px auto 0;\n    bottom: -200px;\n    padding-bottom: 5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font: normal normal 2rem/2.5rem ",
        ", sans-serif;\n    margin-bottom: 4rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}




const ProcessTimelineWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etoo8sr0"
})("background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";box-shadow:0.5rem 0.5rem 1.5rem rgba(23,0,89,0.29);border-radius:0.5rem;position:relative;padding:2rem;width:min(80vw,1170px);margin:0 auto;", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), " ", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), " ", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())));
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "etoo8sr1"
})("font:normal normal 1.5rem/2rem ", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ",sans-serif;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:0 0 2rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3(), theme/* THEME.font.questrial */.C.font.questrial)));
const TimelineImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etoo8sr2"
})("position:relative;display:flex;justify-content:center;");
const TimelineVideo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etoo8sr3"
})("width:100%;height:100%;video{width:100%;}");

// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/sections/ProcessTimeline/ProcessTimeline.tsx






const ProcessTimeline = (param)=>{
    let { image  } = param;
    const { small  } = (0,useWindowSize/* useWindowSize */.i)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProcessTimelineWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                children: "Product Development Timeline"
            }),
            small ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimelineVideo, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("video", {
                    autoPlay: true,
                    muted: true,
                    preload: "auto",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                        src: "/videos/timeline_3.mp4",
                        type: "video/mp4"
                    })
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimelineImage, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    ...(0,imageSerializer/* imageSerializer */.l)(image)
                })
            })
        ]
    });
};


/***/ })

}]);